module.exports = __webpack_public_path__ + "img/6523e4f7c9d5096433c50132_iso27001.ca8edd21.webp";